<script>
import { Doughnut, mixins } from "vue-chartjs";

export default {
  extends: Doughnut,
  mixins: [mixins.reactiveProp],
  props: ["chartData", "chartId"],
  data() {
    return {
      options: {
        cutoutPercentage: 90,
        tooltips: { enabled: false },
        chartId: this.chartId,
        name:'dfdaf',
        hover: {
          mode: null
        },
        legend: {
          display: false
        },
        rotation: -0.5
      }
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  }
};
</script>


// WEBPACK FOOTER //
// src/components/DoughnutChart.vue